import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Typography,
  Form,
  Input,
  Button,
  notification,
  Alert,
  Steps,
  Select
} from "antd";
import PasswordStrengthBar from "react-password-strength-bar";
import "../Signup/Signup.css";
import UserApi from "../common/Apis/UserApi";
import { CheckCircleFilled } from "@ant-design/icons";
import FooterRegistraion from "../common/FooterDashboard/FooterRegistraion";
import RoleApi from "../common/Apis/RoleApi";

const { Title } = Typography;
const Register = (props) => {
  let navigate = useNavigate();
  // Ant Design Notification
  const { placement } = "topRight";
  const [api, contextHolder] = notification.useNotification();

  const [inputPassword, setInputPassword] = React.useState("");
  const [inputValuestart, setinputValuestart] = React.useState(true);
  const [btnDisable, setbtnDisable] = useState(true);

  const [responseSuccess, setresponseSuccess] = useState({
    status: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    // fetchRoles();
    // Page onLoad Scroll Top
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  // Get User Email
  const userEmail = localStorage.getItem("userEmail");
  const tenantID = localStorage.getItem("tenantID");
  const subTenantId = localStorage.getItem("subTenantId");

  // Visible user input password and confirm password

  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [ConfirmPasswordVisible, setConfirmPasswordVisible] =
    React.useState(false);

  const [listRoles, setListRoles] = useState([]);
  const [dropdownValue, setDropdownValue] = useState(null);

  // validating user password strength set value

  const handleChangePassword = (event) => {
    setInputPassword(event.target.value);

    setinputValuestart(false);
  };

  const fetchRoles = () => {
    // setLoadingRoles(true);
    RoleApi.ListAllRoles()
      .then((response) => {
        const roles = Array.isArray(response.payloadDto) ? response.payloadDto : [];
        setListRoles(roles);
        // setLoadingRoles(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoadingRoles(false);
      });
  };

  const filteredRoles = listRoles.filter((role) => {
    return role.code !== "SUPER_ADMIN" && role.code !== "TENANT_ADMIN" && role.code !== "SUB_TENANT_ADMIN";
  });

  const handleSubmit = (data) => {
    let formData;
    if (tenantID == "null") {
      formData = JSON.stringify({
        firstName: data.firstName,
        lastName: data.lastName,
        email: userEmail,
        admin: true,
        password: inputPassword,
        matchingPassword: data.Cpassword,
        tenantDTO: {
          tenantName: data.CompanyName,
        },
        roleDTOs: [
          {
            id: 2,
          },
        ],
      });
    } else if (subTenantId !== "null") {
      formData = JSON.stringify({
        firstName: data.firstName,
        lastName: data.lastName,
        email: userEmail,
        admin: false,
        password: inputPassword,
        matchingPassword: data.Cpassword,
        tenantDTO: {
          id: tenantID,
        },
        subTenantDTO: {
          id: subTenantId,
        },
        roleDTOs: [
          {
            id: 2,
          },
        ]
      });
    } else {
      formData = JSON.stringify({
        firstName: data.firstName,
        lastName: data.lastName,
        email: userEmail,
        password: inputPassword,
        matchingPassword: data.Cpassword,
        tenantDTO: {
          id: tenantID,
        },
        roleDTOs: [
          {
            id: 2,
          },
        ],
      });
    }
    if (data.Cpassword == inputPassword) {
      // register Api
      UserApi.register(formData)
        .then((response) => {
          updateAptitudeTestStatus();
          return navigate("/register-success");
        })
        .catch((err) => {
          // Error Notification
          if (err.apiError.status) {
            notification.open({
              message: <span style={{ fontWeight: "bold" }}>Error</span>,
              description: err.apiError.message,
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#ffb3b3",
                color: "red",
              },
            });
          }
        });
    } else {
      notification.open({
        message: <span style={{ fontWeight: "bold" }}>Error</span>,
        description: "Password Not Match!",
        closeIcon: false,
        duration: 3,
        style: {
          backgroundColor: "#ffb3b3",
          color: "red",
        },
      });
    }
  };
  const updateAptitudeTestStatus = useCallback(() => {
    const formData = new FormData();
    formData.append("email", userEmail);
    formData.append(`aptitudeTestStatus`, "COMPLETED");

    UserApi.updateAptitudeTestStatus(formData).catch((err) => {
      // Error Notification
      if (err) {
        api.error({
          message: `${err}`,
          placement,
        });
      }
    });
  }, [api, userEmail]);

  // Registration  Steps
  const items = [
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 1</p>
            <h4>
              <b>Induction</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 2</p>
            <h4>
              <b>MCQ Test</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 3</p>
            <h4>
              <b>Protective Clothing</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 4</p>
            <h4>
              <b>Health Questionnaire</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 5</p>
            <h4>
              <b>Registraion</b>
            </h4>
            <p className="process">In Progress</p>
          </div>
        </>
      ),
      status: "process",
    },
  ];

  const customDot = (dot, { status }) => {
    switch (status) {
      case "finish":
        return <CheckCircleFilled />;
      case "process":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      case "wait":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      default:
        return dot;
    }
  };

  const getPasswordStrength = (score) => {
    if (score < 2) {
      return "Weak";
    } else if (score === 2) {
      return "Good";
    } else {
      return "Strong";
    }
  };
  const handlePasswordStrengthChange = (score) => {
    const strength = getPasswordStrength(score);
    if (strength !== "Weak") {
      setbtnDisable(false);
    } else {
      setbtnDisable(true);
    }
  };
  return (
    <>
      <div
        className="logo-title"
        style={{ boxShadow: "3px 3px 10px -4px rgba(0, 0, 0, 0.1)" }}
      >
        <img
          src="/assest/Images/Logo/logo.png"
          className="logo-png"
          style={{ width: "14%" }}
        />
      </div>
      <div className="container form-container pt-3">
        {contextHolder}
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-10 col-md-12 px-0">
            <Steps
              current={4}
              labelPlacement="vertical"
              items={items}
              progressDot={customDot}
            />
          </div>
          <div className="col-xl-5 col-lg-5 col-md-9 content-border">
            <Form
              name="nest-messages"
              layout="vertical"
              onFinish={handleSubmit}
            >
              <div className="d-flex justify-content-center pt-4">
                <img
                  src="/assest/Images/Logo/logo.png"
                  className="logo-png"
                />
              </div>
              <Title
                style={{
                  textAlign: "center",
                  color: "black",
                  marginBottom: 40,
                  paddingTop: 10,
                }}
                level={3}
              >
                Join iVA Foodflow
              </Title>
              <Form.Item
                name="firstName"
                className="text-lable"
                rules={[
                  {
                    required: true,
                    message: "Please enter your first name.",
                  },
                  {
                    pattern: /^[A-Za-z]+$/,
                    message: "Only alphabet characters are allowed.",
                  },
                ]}
              >
                <Input
                  type="text"
                  className="form-control control-input"
                  placeholder="Choose a First Name"
                />
              </Form.Item>

              <Form.Item
                name="lastName"
                className="text-lable"
                rules={[
                  {
                    required: true,
                    message: "Please enter your last name.",
                  },
                  {
                    pattern: /^[A-Za-z]+$/,
                    message: "Only alphabet characters are allowed.",
                  },
                ]}
              >
                <Input
                  type="text"
                  className="form-control control-input"
                  placeholder="Choose a Last Name"
                />
              </Form.Item>
              {/* <Form.Item>
                <Select
                  placeholder="Select a role"
                  style={{ width: "100%" }}
                  value={dropdownValue}
                  onChange={(value) => {
                    // setDropdownValue(value);
                    // setDropdownError("");
                  }}
                  options={filteredRoles.map((role) => ({
                    label: role.name,
                    value: role.id,
                  }))}
                />
              </Form.Item> */}
              {tenantID === "null" && (
                <Form.Item
                  name="CompanyName"
                  className="text-lable"
                  rules={[
                    {
                      required: tenantID === "null" ? true : false,
                      message: "Only alphabet characters are allowed.",
                    },
                    {
                      pattern: /^[A-Za-z\s]+$/,
                      message: "Only alphabet characters are allowed.",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    className="form-control control-input"
                    placeholder="Choose a Company Name"
                  />
                </Form.Item>
              )}
              <Form.Item name="password" className="text-lable">
                <Input.Password
                  placeholder="Choose a Password"
                  className="control-input mb-2"
                  onChange={handleChangePassword}
                  type="password"
                  visibilityToggle={{
                    visible: passwordVisible,
                    onVisibleChange: setPasswordVisible,
                  }}
                />

                {inputPassword !== "" ? (
                  <>
                    <PasswordStrengthBar
                      className="password-progress"
                      password={inputPassword}
                      minLength={5}
                      onChangeScore={handlePasswordStrengthChange}
                    />
                  </>
                ) : (
                  <>
                    {inputValuestart === true ? (
                      <>
                        <p className="content-info ">
                          8 characters or longer. Combine upper and lowercase
                          letters and numbers.
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="content-info " style={{ color: "red" }}>
                          Password must be min. 8 characters. Combine numbers,
                          special characters, upper and lowercase letters.
                        </p>
                      </>
                    )}
                  </>
                )}
              </Form.Item>
              <Form.Item name="Cpassword" className="text-lable">
                <Input.Password
                  placeholder="Confirm Password"
                  className="control-input"
                  visibilityToggle={{
                    visible: ConfirmPasswordVisible,
                    onVisibleChange: setConfirmPasswordVisible,
                  }}
                />
              </Form.Item>
              {responseSuccess.status == true && (
                <Alert
                  message={responseSuccess.message}
                  type={responseSuccess.type}
                  className="mb-3"
                  banner
                />
              )}
              <Button
                type="primary"
                htmlType="submit"
                className="btn btn-primary mt-0 w-100"
                disabled={btnDisable}
              >
                Sign Up
              </Button>

              <p className="content-info pt-4 mb-0 text-center">
                By joining, you agree to iVA Foodflow <Link to={""} className="content-info-link">
                  Teams of Service
                </Link>
              </p>
            </Form>
            <p className="content signup-content">
              Already a member?{" "}
              <Link to={"/"} className="content-link">
                Sign In
              </Link>
            </p>
          </div>
          <FooterRegistraion />
        </div>
      </div>
    </>
  );
};

export default Register;